import React from 'react'
import { bool, string } from 'prop-types'
import { css } from '@emotion/css'

const inputTextFieldStyles = css`
  border: none;
  border-radius: 12px;
  height: 40px;
  padding-left: 8px;
  font-family: 'Titillium Web';
  width: 190px;
`

const InputTextField = ({ fullWidth, className, ...props }) => (
  <input className={[inputTextFieldStyles, className].join(' ')} type="text" {...props} />
)

InputTextField.propTypes = {
  fullWidth: bool,
  className: string,
}

InputTextField.defaultProps = {
  fullWidth: false,
  className: '',
}

export default InputTextField
